import React from 'react';
import { createRoot } from 'react-dom/client';

import { Footer } from './Footer';

import type { FooterData } from './types';

declare global {
  interface Window {
    InteractFooterData?: FooterData;
  }
}

const mountNode = document.getElementById('interact-footer-react-root');
const footerData = window.InteractFooterData;

if (mountNode && footerData) {
  const root = createRoot(mountNode);
  root.render(
    <React.StrictMode>
      <Footer data={footerData} />
    </React.StrictMode>,
  );
} else if (!footerData) {
  // eslint-disable-next-line no-console
  console.warn('Interact footer data is not available.');
}
